export default {
    dependencies: ['$element'],
    callable(ele) {
        const buttonEle = ele.querySelector('[data-button]');
        if (!buttonEle) {
            return;
        }
        const descriptionEle = ele.querySelector('[data-profile-description]');
        if (!descriptionEle) {
            return;
        }

        let isExpanded = ele.classList.contains('profile--is-open');

        buttonEle.addEventListener('click', () => {
            ele.classList.toggle('profile--is-open', !isExpanded);
            buttonEle.setAttribute('aria-expanded', isExpanded);
            isExpanded = !isExpanded;
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/toggleProfileDescription.js